module.exports = __webpack_public_path__ + "static/media/hatti-in-janti.6f60ea51.gif";